import { Link } from '@apollo/orbit';
import React from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';
import { DocsRouter } from 'src/lib/routers';

export function ErrorCountTooltip({
  isUsingLegacyStats,
  isFederated,
  children,
}: {
  isUsingLegacyStats: boolean;
  isFederated: boolean;
  children: React.ReactElement;
}) {
  return (
    <Tooltip
      interactive
      label={
        isUsingLegacyStats ? (
          isFederated ? (
            // Legacy + Federated
            <p>
              The total number of errors reported from subgraphs. This
              represents the subset of errors captured via{' '}
              <Link to={DocsRouter.path('FederatedTracing')} isExternal>
                Federated Tracing
              </Link>
              . Note that this excludes errors that occur at the Router /
              Gateway layer. For more comprehensive error metrics including
              error codes, upgrade to router ≥ 2.1.2 and{' '}
              <Link to={DocsRouter.path('ExtendedErrorConfig')} isExternal>
                enable extended error reporting.
              </Link>
            </p>
          ) : (
            // Legacy + Monolith
            <p>
              The total number of errors reported. For more comprehensive error
              metrics including error codes, upgrade to router ≥ 2.1.2 and{' '}
              <Link to={DocsRouter.path('ExtendedErrorConfig')} isExternal>
                enable extended error reporting.
              </Link>
            </p>
          )
        ) : (
          // Extended errors
          <p>
            The total number of errors reported. To learn more, see the docs on{' '}
            <Link to={DocsRouter.path('ExtendedErrorConfig')} isExternal>
              error diagnostics.
            </Link>
          </p>
        )
      }
    >
      {children}
    </Tooltip>
  );
}
